import { render, staticRenderFns } from "./ResellerCreate.vue?vue&type=template&id=1ae7becb&"
import script from "./ResellerCreate.vue?vue&type=script&lang=js&"
export * from "./ResellerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports